import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'unit'
})
export class UnitPipe implements PipeTransform {

    transform(value: number, unit?: string): any {
        let unitValue: number;
        let unitSuffix: string;
        switch (unit) {
            case 'mega':
                unitValue = 1000000;
                unitSuffix = 'MB';
                break;
            case 'giga':
                unitValue = 1000000000;
                unitSuffix = 'GB';
                break;
            case 'tera':
                unitValue = 1000000000000;
                unitSuffix = 'TB';
                break;
            default:
                unitValue = 1000;
                unitSuffix = 'kB';
        }
        return Math.round(value / unitValue).toString() + ' ' + unitSuffix;
    }

}
